
import React, { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { userInvites } from '@/integrations/supabase/client';
import UsersManager from './UsersManager';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const UserManagement = () => {
  const [invites, setInvites] = useState([]);
  const [invitesLoading, setInvitesLoading] = useState(true);
  const [invitesError, setInvitesError] = useState<string | null>(null);

  const fetchInvites = async () => {
    try {
      setInvitesLoading(true);
      setInvitesError(null);
      
      const { data, error } = await userInvites()
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching invites:', error);
        setInvitesError('Failed to load user invites');
        throw error;
      }
      
      setInvites(data || []);
    } catch (error: any) {
      console.error('Error in fetchInvites:', error);
      setInvitesError(error.message || 'Failed to load user invites');
    } finally {
      setInvitesLoading(false);
    }
  };

  useEffect(() => {
    fetchInvites();
  }, []);

  return (
    <Card>
      <CardContent className="p-6">
        {invitesError && (
          <Alert variant="destructive" className="mb-4">
            <AlertDescription>
              {invitesError}
            </AlertDescription>
          </Alert>
        )}
        
        <UsersManager />
      </CardContent>
    </Card>
  );
};

export default UserManagement;
